(function () {
    "use strict";

    angular
        .module("app")
        .directive("customerTypeAhead", ["PatternService", customerTypeAhead]);

    function customerTypeAhead(patternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return patternService.getCustomers(searchText).then(function (response) {
                        return response ? response : [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.CustomerKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "="},
            template: '<input' +
                ' uib-typeahead="item.CustomerName for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();